$(document).ready(function(){
    // function priceUpdate(multiplier){
    //     $('span.appstle_subscription_amount.transcy-money').each(function(){
    //         var totalPrice = $(this).text();
    //         //alert(totalPrice);
    //         var totalPrice = $(this).text().replace('$',''); // remove $
    //         var numericPrice = parseFloat(totalPrice);       // convert to number

    //         if (!isNaN(numericPrice)) {
    //             var updatedPrice = numericPrice * multiplier; 
    //             $(this).text('$' + updatedPrice.toFixed(2)); // format with 2 decimals
    //         }
    //     });
    // }
    

    var getVariantTitle = $('.product .product-form__input--pill input[type=radio]:checked').val();
    //alert(getVariantTitle);
    if(getVariantTitle == '6 PACK (+2 FREE)') {
        $('.bundle_product_box[variantname="6 PACK (+2 FREE)"]').show().addClass('active_bundle');
        $('.bundle_product_box[variantname="3 PACK"]').hide().removeClass('active_bundle');
        $('.custom_add_to_cart .button').attr('bundle', 'true');
        //$('#custom_quantity_prd').val(6);
        // setTimeout(function(){
        //     priceUpdate(6);
        // }, 1300);
    }else if (getVariantTitle == '3 PACK'){
        $('.bundle_product_box[variantname="3 PACK"]').show().addClass('active_bundle');
        $('.bundle_product_box[variantname="6 PACK (+2 FREE)"]').hide().removeClass('active_bundle');
        $('.custom_add_to_cart .button').attr('bundle', 'true');
        //$('#custom_quantity_prd').val(3);
        // setTimeout(function(){
        //     priceUpdate(3);
        // }, 1300);
    }else {
        $('.bundle_product_box[variantname="3 PACK"]').hide().removeClass('active_bundle');
        $('.bundle_product_box[variantname="6 PACK (+2 FREE)"]').hide().removeClass('active_bundle');
        //$('#custom_quantity_prd').val(1); 
        // setTimeout(function(){
        //     priceUpdate(1);
        // }, 1300);
    }

    $(document).on("change", "select.appstle_select", function() {
        var getVariantTitleOnsell = $('.product .product-form__input--pill input[type=radio]:checked+label').prev().val();
        setTimeout(function(){
          //alert(getVariantTitleOnsell);
            if(getVariantTitleOnsell == '6 PACK (+2 FREE)') {
            setTimeout(function(){
                    priceUpdate(6);
                }, 1300);
            }else if (getVariantTitleOnsell == '3 PACK'){
                setTimeout(function(){
                    priceUpdate(3);
                }, 1300);
            }else {
                setTimeout(function(){
                    priceUpdate(1);
                }, 1300);
            }
        },500)
        
        //alert("changed");
       
    });
    var  changeVariantTitle;
    $(document).on('click', '.product .product-form__input--pill label', function(){
        changeVariantTitle = $(this).prev().val();
        // alert(changeVariantTitle);
        if(changeVariantTitle == '6 PACK (+2 FREE)') {
            $('.bundle_product_box[variantname="6 PACK (+2 FREE)"]').slideDown().addClass('active_bundle');
            $('.bundle_product_box[variantname="3 PACK"]').slideUp().removeClass('active_bundle');
            $('.custom_add_to_cart .button').attr('bundle', 'true');
            //$('#custom_quantity_prd').val(6);
            // setTimeout(function(){
            //     priceUpdate(6);
            // }, 1300);
        }else if (changeVariantTitle == '3 PACK'){
            $('.bundle_product_box[variantname="3 PACK"]').slideDown().addClass('active_bundle');
            $('.bundle_product_box[variantname="6 PACK (+2 FREE)"]').slideUp().removeClass('active_bundle');
            $('.custom_add_to_cart .button').attr('bundle', 'true');
            //$('#custom_quantity_prd').val(3);
            // setTimeout(function(){
            //     priceUpdate(3);
            // }, 1300);
        }
        else {
             $('.bundle_product_box[variantname="3 PACK"]').slideUp().removeClass('active_bundle');
             $('.bundle_product_box[variantname="6 PACK (+2 FREE)"]').slideUp().removeClass('active_bundle');
            $('.custom_add_to_cart .button').attr('bundle', 'false');
            //$('#custom_quantity_prd').val(1); 
            // setTimeout(function(){
            //     priceUpdate(1);
            // }, 1300);
        }
    });
    $(document).on('click', '.custom_add_to_cart .button[bundle="false"]', function(){
        
        $('.product-form__submit').trigger('click');
        $('.custom_add_to_cart .button[bundle="false"] .loading__spinner').removeClass('hidden');
    });
    
    $(document).on('change', '.product_element', function() {
        var $select = $(this);

        if ($select.find('option:first').is(':selected')) {
            $select.addClass("not_selected");
        } else {
            $select.removeClass("not_selected");
        }
    });

    $(document).on('click', '.custom_add_to_cart .button[bundle="true"]', function() {
        
        var uniqueCode = "U-" + Date.now();
    var items = [];
                var productCount = 1;
                var $form = $(".bundle_property_main_prd");
                //alert($form);
                
                $form.find(".bundle-property").remove();
                var selectedValues = [];
                var url = window.location.href;
                var urlParams = new URLSearchParams(window.location.search);
                var sellingPlanId = urlParams.get("selling_plan");
                var mainPrdSellPlan; 
                var mainPrdTitle = $('.product__title h1').text();
                var getVariantTitlecart = $('.product .product-form__input--pill input[type=radio]:checked').val();
                mainPrdTitle = mainPrdTitle +" "+  getVariantTitlecart ;
                //alert(getVariantTitlecart);

                if (sellingPlanId) {
                    //alert("Selling Plan ID: " + sellingPlanId);
                    mainPrdSellPlan = $(".appstle_select option:selected").text();
                    mainPrdSellPlan = mainPrdSellPlan.toLowerCase().replace(/\s+/g, "-");
                    //alert(mainPrdSellPlan);
                }
            $('.active_bundle .product_element').each(function() {
                var $select = $(this);
                var selectedOption = $select.find('option:selected'); 
                var productAvalId = selectedOption.attr("product_aval_id"); 
                var value = selectedOption.val();
                if (sellingPlanId) {
                   var sellingPlan = selectedOption.attr(mainPrdSellPlan);
                }
                if (!$select.find('option:first').is(':selected')) {
                    $select.removeClass("not_selected");

                    // Push variant + selling plan into items array
                    var item = {
                        id: productAvalId,
                        quantity: 1,
                        properties: {
                            "Included In": mainPrdTitle,
                            "Bundle": uniqueCode
                        }
                    };
                    if (sellingPlanId) {
                        if (sellingPlan) {
                            item.selling_plan = sellingPlan;
                        }
                    }

                    items.push(item);
                } else {
                    $select.addClass("not_selected");
                }

                if (value && value !== "") {
                    selectedValues.push(value);
                }
            });

            var bundleNotSelectLength = $('.active_bundle .product_element.not_selected').length;
            if(bundleNotSelectLength == 0){
                $.each(selectedValues, function (i, val) {
                        //alert(val);
                        var input = $('<input>', {
                            type: 'hidden',
                            class: 'bundle-property',
                            name: 'properties[Product ' + (i + 1) + ']',
                            value: val
                        });

                        $form.append(input);
                    });
                $('.custom_add_to_cart .button[bundle="true"] .loading__spinner').removeClass('hidden');
                if (items.length > 0) {
                    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify({ items: items }),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function(cart) {
                             $('#bundleUniCode').attr('value', uniqueCode);
                            setTimeout(function(){
                              $('.product-form__submit').trigger('click');
                              console.log("Added to cart:", cart);
                            },500);
                            // optionally redirect to cart
                            // window.location.href = '/cart';
                        },
                        error: function(err) {
                            console.error("Error adding to cart:", err);
                        }
                    });
                } else {
                    alert("Please select at least one product option.");
                }
            }
});


});